const StockControl = () => import(/* webpackChunkName: "stockControl" */ './StockControl.vue')

const index = {
  path: 'stock/control',
  name: 'Stock Control',
  component: StockControl,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
